module.exports = __webpack_public_path__ + "img/calendar.547ff1ff.svg";